module.exports = __webpack_public_path__ + "img/file---@1x.77243440.png";